var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon29(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5475_55145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9024 5.24525C14.531 2.31955 12.0252 0.0500488 9 0.0500488C6.6574 0.0500488 4.6225 1.4194 3.69345 3.57755C1.86765 4.12325 0.5 5.84705 0.5 7.70005C0.5 10.0435 2.40655 11.95 4.75 11.95H5.6V10.25H4.75C3.3441 10.25 2.2 9.10595 2.2 7.70005C2.2 6.50665 3.21915 5.3566 4.47205 5.13645L4.9659 5.04975L5.1291 4.57545C5.72665 2.8321 7.2099 1.75005 9 1.75005C11.3435 1.75005 13.25 3.6566 13.25 6.00005V6.85005H14.1C15.0375 6.85005 15.8 7.6125 15.8 8.55005C15.8 9.4876 15.0375 10.25 14.1 10.25H12.4V11.95H14.1C15.9751 11.95 17.5 10.4251 17.5 8.55005C17.499 7.78804 17.2425 7.04837 16.7717 6.44927C16.3008 5.85017 15.6426 5.42624 14.9024 5.24525Z",
    fill: "url(#paint0_linear_5475_55145)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84961 7.70005V4.30005H8.14961V7.70005H5.59961L8.99961 11.95L12.3996 7.70005H9.84961Z",
    fill: "url(#paint1_linear_5475_55145)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5475_55145",
    x: 0.5,
    y: 0.0500488,
    width: 18,
    height: 12.8999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.529167 0 0 0 0 0.46285 0 0 0 0 0.251354 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5475_55145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5475_55145",
    x1: 9,
    y1: -2.09195,
    x2: 9,
    y2: 13.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5475_55145",
    x1: 8.99961,
    y1: 2.92305,
    x2: 8.99961,
    y2: 13.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon29);
export default __webpack_public_path__ + "static/media/icon29.be78c870adf14b1751fc351d3ec24957.svg";
export { ForwardRef as ReactComponent };